import React from 'react';

export default function Root() {
  return (
    <div className="flex w-100 h-100 flex-center flex-column" />
  );
}
